import { postSignInAuthorizeApi, postSignInTokenApi } from "@/services/signIn";
import { getErrorCode } from "@/utils/api.config";
import i18next from "i18next";
import crypto from "crypto-browserify";
import * as types from "../types/index";

const base64URLEncode = (str) => {
  return str
    .toString("base64")
    .replace(/\+/g, "-")
    .replace(/\//g, "_")
    .replace(/=/g, "");
};

const sha256 = (buffer) => {
  return crypto.createHash("sha256").update(buffer).digest();
};

const postLogin = (loginData, isAzure) => {
  return async (dispatch) => {
    try {
      dispatch({ type: types.POST_LOGIN });
      const verifier = base64URLEncode(crypto.randomBytes(32));
      const challenge = base64URLEncode(sha256(verifier));

      let postAuthorizeObj = {
        email: loginData.email,
        password: loginData.password,
        response_type: "code",
        client_id: import.meta.env.VITE_OAUTH_CLIENT_ID,
        redirect_uri: import.meta.env.VITE_OAUTH_REDIRECT_URI,
        scope: "read write",
        code_challenge: challenge,
        code_challenge_method: "S256",
      };

      if (isAzure) {
        postAuthorizeObj["email"] = loginData.email;
        postAuthorizeObj["microsoft_id"] = loginData.microsoft_id;
        postAuthorizeObj["microsoft_token"] = loginData.microsoft_token;
      } else {
        postAuthorizeObj["email"] = loginData.email;
        postAuthorizeObj["password"] = loginData.password;
      }

      // call authorize api and get oAuth Authorization Code in response
      const authResponse = await postSignInAuthorizeApi(postAuthorizeObj);

      if (authResponse.data && authResponse.data.code) {
        const postTokenObj = {
          client_id: import.meta.env.VITE_OAUTH_CLIENT_ID,
          client_secret: import.meta.env.VITE_OAUTH_CLIENT_SECRET,
          redirect_uri: import.meta.env.VITE_OAUTH_REDIRECT_URI,
          code_verifier: verifier,
          grant_type: "authorization_code",
          code: authResponse.data.code,
          email: loginData.email,
        };

        // call token api and get Access Token in response
        const tokenResponse = await postSignInTokenApi(postTokenObj);

        dispatch({
          type: types.POST_LOGIN_SUCCESS,
          payload: {
            data: tokenResponse.data,
          },
        });
      }
    } catch (error) {
      let errorCode = getErrorCode(error);
      let message = i18next.t("Authentication failed");
      if (errorCode) {
        switch (errorCode) {
          case 500:
            message = i18next.t("Authentication failed");
            break;
          case 401:
            message =
              error &&
              error.response &&
              error.response.data &&
              error.response.data.message
                ? error.response.data.message
                : i18next.t(
                    "Incorrect email/password combination. Please try again"
                  );
            break;
          case 404:
            message = i18next.t(
              "Incorrect email/password combination. Please try again"
            );
            break;
          default:
            message = i18next.t("Authentication failed");
            break;
        }
      }
      dispatch({
        type: types.POST_LOGIN_FAILURE,
        payload: { error: message },
      });
    }
  };
};

export const actions = {
  postLogin,
};
